import styles from './style.module.css';

export default function BtnWithTip({className,onClick,defaultText,changeText=null,pos="bottom"}){
    return(
        <div className={`${className} ${styles['parent']}`} onClick={onClick}>
            <div className={`${styles['wrap']} ${styles['wrap-'+pos]}`}>
                <div className={`${styles['head']} ${styles['head-'+pos]} ${changeText&&styles['active']}`} ></div>
                <div className={`${styles['body']} ${changeText&&styles['active']}`}>{changeText?changeText:defaultText}</div>
            </div>
        </div>
    )
}